/* eslint-disable */
import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import VueCryptojs from 'vue-cryptojs'
import VueGtag from 'vue-gtag'

import router from './router'
import store from './store'
import App from './App.vue'

import VueAnimate from "vue-animate-scroll"
import VueWow from "vue-wow"

import AOS from 'aos'
import 'aos/dist/aos.css'

import "animate.css"

// Global Components
import './global-components'
// import './install-composition-api'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/print-html'

// Composition API
Vue.use(VueCompositionAPI)
Vue.use(VueCryptojs)

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

Vue.use(VueAnimate)
Vue.use(VueWow)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false
Vue.use(VueGtag, {
  config: { id: 'UA-208092779-1' }
  // config: { id: 'G-5JZ1ZC3VJ1' }
}, router);

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

new Vue({
  router,
  store,
  created () {
    AOS.init()
  },
  render: h => h(App),
}).$mount('#app')
